import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=78dfb5f4&scoped=true"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"
import style0 from "./Description.vue?vue&type=style&index=0&id=78dfb5f4&prod&lang=css&scoped=true"
import style1 from "./Description.vue?vue&type=style&index=1&id=78dfb5f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dfb5f4",
  null
  
)

export default component.exports